// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"870":"46c7c7c7","879":"6e23e7e4","916":"036e905f","924":"80c91c7c"}[chunkId] + ".css";
};